import DialogShared from "./DialogShared";

export default DialogShared;
